var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddtopic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2721 2.58333L13.0031 1.90101C12.814 1.69837 12.5493 1.58333 12.2721 1.58333V2.58333ZM7.09985 2.58333V1.58333V2.58333ZM5.62207 4.16666H4.62207H5.62207ZM5.62207 16.8333H4.62207H5.62207ZM17.4443 8.125H18.4443C18.4443 7.8717 18.3482 7.62785 18.1753 7.44268L17.4443 8.125ZM12.2721 1.58333H7.09985V3.58333H12.2721V1.58333ZM7.09985 1.58333C6.41957 1.58333 5.78235 1.8735 5.32385 2.36476L6.78596 3.72939C6.88173 3.62678 6.99627 3.58333 7.09985 3.58333V1.58333ZM5.32385 2.36476C4.86752 2.85368 4.62207 3.50293 4.62207 4.16666H6.62207C6.62207 3.99054 6.68801 3.83434 6.78596 3.72939L5.32385 2.36476ZM4.62207 4.16666V16.8333H6.62207V4.16666H4.62207ZM4.62207 16.8333C4.62207 17.4971 4.86752 18.1463 5.32385 18.6352L6.78596 17.2706C6.68801 17.1657 6.62207 17.0094 6.62207 16.8333L4.62207 16.8333ZM5.32385 18.6352C5.78235 19.1265 6.41957 19.4167 7.09985 19.4167V17.4167C6.99627 17.4167 6.88173 17.3732 6.78596 17.2706L5.32385 18.6352ZM7.09985 19.4167H12.6415V17.4167H7.09985V19.4167ZM18.4443 13.2708V8.125H16.4443V13.2708H18.4443ZM18.1753 7.44268L13.0031 1.90101L11.541 3.26565L16.7132 8.80731L18.1753 7.44268Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.272 2.58333V8.12499H17.4442",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1333 14.7083V22.2917",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5942 18.5H20.672",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddtopic);
export default __webpack_public_path__ + "static/media/Addtopic.397907a71766a9e38fa03107bcca51be.svg";
export { ForwardRef as ReactComponent };